import { Messages } from '../../../gen-src/Localize';
import { FieldDataType } from '../../../gen-src/queries/globalTypes';

export type NameAndDataType = {
  name: string | null;
  dataType: FieldDataType | null;
};

export function getNameWithApplicableDataType({ name, dataType }: NameAndDataType): string {
  return (dataType === FieldDataType.TABLE ? Messages.FieldNameWithCount({ FieldName: name || '' }) : name) || '';
}
